import _extends from "@babel/runtime/helpers/extends";
// Extracted from @atlassian/recent-work-ui activity-event-type-message to create this
// helper function to convert timestamp to readable metadata
import React from 'react';
import { FormattedMessage, FormattedDate, FormattedRelativeTime } from 'react-intl-next';
import isBefore from 'date-fns/isBefore';
import startOfDay from 'date-fns/startOfDay';
import subWeeks from 'date-fns/subWeeks';
import { selectUnit, useEventTypeMessage } from '@atlassian/recent-work-ui';
export var VIEWED_EVENT = /*#__PURE__*/function (VIEWED_EVENT) {
  VIEWED_EVENT["VIEWED"] = "viewed";
  return VIEWED_EVENT;
}({});
export var WORKED_EVENT = /*#__PURE__*/function (WORKED_EVENT) {
  WORKED_EVENT["COMMENTED"] = "commented";
  WORKED_EVENT["CREATED"] = "created";
  WORKED_EVENT["EDITED"] = "edited";
  WORKED_EVENT["PUBLISHED"] = "published";
  WORKED_EVENT["UPDATED"] = "updated";
  return WORKED_EVENT;
}({});
export function isMoreThanOneWeekAgo(date) {
  return isBefore(new Date(date), startOfOneWeekAgo());
}
function startOfOneWeekAgo() {
  return startOfDay(subWeeks(new Date(), 1));
}

// TODO: we could replace this component with EventTypeMessage from @atlassian/recent-work-ui
export var EventTypeMessage = function EventTypeMessage(_ref) {
  var eventType = _ref.eventType,
    timestamp = _ref.timestamp,
    _ref$isMyActivityData = _ref.isMyActivityData,
    isMyActivityData = _ref$isMyActivityData === void 0 ? true : _ref$isMyActivityData;
  var isAbsolute = isMoreThanOneWeekAgo(timestamp);
  var message = useEventTypeMessage(eventType, {
    isMyActivityData: isMyActivityData,
    isAbsolute: isAbsolute
  });
  var _selectUnit = selectUnit(new Date(timestamp).getTime(), new Date(), {
      day: 7
    }),
    value = _selectUnit.value,
    unit = _selectUnit.unit;
  var values = isAbsolute ? {
    // Show the absolute time if the activity was more than a week ago
    // e.g: You viewed on January 1, 2021
    absoluteTime: /*#__PURE__*/React.createElement(FormattedDate, {
      value: timestamp,
      month: "short",
      day: "2-digit",
      year: "numeric"
    })
  } : {
    // Show the relative time if the activity was within a week ago
    // e.g: You viewed 2 hours ago
    relativeTime: /*#__PURE__*/React.createElement(FormattedRelativeTime, {
      value: value,
      unit: unit
    })
  };
  return /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, message, {
    values: values
  }));
};